<template>
  <div>
    <div v-for="(content, key) in payload" :key="key">
      <div style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"  v-if="!content.pass">
        <p style="font-size: 18px;"><b>{{key}}: </b> <span style="color: red;">NOT PASSED</span></p>
        <div v-if="content.info != undefined">
          <p v-for="(info_key_content, info_key) in content.info" :key="info_key"><b>{{info_key}}: </b> {{content.info[info_key].toString()}}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'pass-validator',
  props: ['payload']
}
</script>
